<template>
  <p v-if="hasNote" class="checkpoint-prep-note-block">{{ plainText }}</p>
</template>

<script setup>
import { computed } from "vue";
import { htmlToParagraphs } from "@components/utils/buildCheckpointDrawerSections";

const props = defineProps({
  note: {
    type: String,
    default: null,
  },
});

const hasNote = computed(() => String(props.note ?? "").trim().length > 0);

const plainText = computed(() => htmlToParagraphs(props.note).join("\n\n"));
</script>

<style scoped>
.checkpoint-prep-note-block {
  margin: 0;
  color: #475467;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
